import React from "react"
import { Rule } from "@mui/icons-material"
import { FilledInput, FormControl, IconButton, Input, InputAdornment, InputBase, InputLabel, List, ListItem, ListItemButton, ListItemText, Paper, Popover, TextField, Tooltip, Typography } from "@mui/material"
import Service from "../../../../util/Service";
import SearchField from "../../../util/SearchField";

export default function RulesPopover(props) {

    const { user, regras, regra, ml, showTxt, currentRoles, action } = props;
    const [lst, setLst] = React.useState();
    const [lstFiltrada, setLstFiltrada] = React.useState();
    const [anchorElPopover, setAnchorElPopover] = React.useState(null);
    const openPopover = Boolean(anchorElPopover);
    const idPopover = openPopover ? 'simple-popover' : undefined;

    React.useEffect(() => {
        if (openPopover) {
            if (regras) {
                const arr = [];
                inner: for (const x of regras) {
                    if (user && user.rules) {
                        for (const y of user.rules) {
                            if (x.nome === y) continue inner;
                        }
                    }
                    if( currentRoles ){
                        for (const y of currentRoles) {
                            if (x.nome === y) continue inner;
                        }
                    }
                    arr.push(x)
                }
                setLst(arr);
                setLstFiltrada(arr);
            } else {
                Service.GET("/api/acesso/findAll").then(r => {
                    // setLst(r);
                    // setLstFiltrada(r);
                    const arr = [];
                    setLst(r);
                    inner: for (const x of r) {
                        if (user && user.rules) {
                            for (const y of user.rules) {
                                if (x.nome === y) continue inner;
                            }
                        }
                        if( currentRoles ){
                            for (const y of currentRoles) {
                                if (x.nome === y) continue inner;
                            }
                        }
                        arr.push(x)
                    }
                    
                    setLstFiltrada(arr);
                })
            }
        }
    }, [openPopover])

    React.useEffect(() => {        
        if( currentRoles && lst ){
            const arr = lst.filter( l => {
                const item = currentRoles.find( cr => cr.nome === l.nome)
                if( item) return false;
                return true;
            });
            setLstFiltrada(arr);
        }
    },[currentRoles]);

    const handleClickPopover = (event) => {
        setAnchorElPopover(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorElPopover(null);
    };
    
    function handleChange(e){
        // setNome(e.target.value);
        if (action) action(
            {nome: e.target.value}
        );
    }
    function handleAddRule(row) {
        if (action) action(row);

        handleClosePopover();
    }
    function handleSearch(txt){
        const arr = lst.filter( r => {

            const item = currentRoles && currentRoles.find( cr => cr.nome === r.nome)
            if( item) return false;

            if( r.nome.toUpperCase().includes( txt.toUpperCase() )){
                return true;
            }
            if( r.descricao.toUpperCase().includes( txt.toUpperCase() )){
                return true;
            }
            return false;
        })
        if( arr) setLstFiltrada( arr)
    }
    return (
        <React.Fragment>
            {showTxt === true &&
                <TextField placeholder="Regra" variant="outlined" size="small"
                    value={regra} onChange={handleChange}
                    slotProps={{
                        input: {
                            endAdornment: (
                            <InputAdornment position="end">
                                <IconButton aria-label="search" onClick={handleClickPopover}>
                                    <Rule />
                                </IconButton>
                            </InputAdornment>
                            ),
                            readOnly: true,
                        },
                        }}
                />
            }

            {!showTxt &&
                <Tooltip title="Incluir nova regra" sx={{ ml: ml ? ml : 0 }}>
                    <IconButton aria-label="reprocessar" color="primary" onClick={handleClickPopover}>
                        <Rule />
                    </IconButton>
                </Tooltip>}
            <Popover
                id={idPopover}
                open={openPopover}
                anchorEl={anchorElPopover}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div style={{display:'flex', justifyContent:'center'}}>
                    <SearchField width='250px' handleSearch={handleSearch}/>
                </div>
                <List
                    sx={{
                        width: 360, maxWidth: 360, bgcolor: 'background.paper',
                        overflow: 'auto', mt:'2px',
                        maxHeight: 450,
                    }}
                >
                    {lstFiltrada && lstFiltrada.map((row, id) =>
                        <ListItem
                            alignItems="flex-start" key={"list-popover-" + id}
                        >
                            <ListItemButton onClick={() => handleAddRule(row)}>
                                <ListItemText
                                    primary={row.nome}
                                    secondary={row.descricao}
                                />
                            </ListItemButton>
                        </ListItem>
                    )}

                </List>
            </Popover>
        </React.Fragment>
    )
}